import { Avatar, Button, Pagination, Table } from "flowbite-react";
import React, { useState } from "react";
import { baseUrl } from '../config';



const PastCollaborations = () => {
  const pastInfluencers = [
    { name: "Mark White", location: "Toronto, Canada", followers: 90000 },
    { name: "Sarah Blue", location: "Berlin, Germany", followers: 50000 },
    { name: "Alex Green", location: "Los Angeles, USA", followers: 120000 },
    { name: "Emma Brown", location: "Sydney, Australia", followers: 150000 },
    { name: "John Doe", location: "New York, USA", followers: 300000 },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInfluencers = pastInfluencers.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(pastInfluencers.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <section className="mt-12 p-4">
      <h2 className="text-2xl font-bold mb-4">Past Collaborations</h2>
      <Table hoverable={true}>
        <Table.Head>
          <Table.HeadCell>Name</Table.HeadCell>
          <Table.HeadCell>Location</Table.HeadCell>
          <Table.HeadCell>Followers</Table.HeadCell>
          <Table.HeadCell>Status</Table.HeadCell>
          <Table.HeadCell></Table.HeadCell>
        </Table.Head>
        <Table.Body className="divide-y">
          {currentInfluencers.map((influencer, index) => (
            <Table.Row
              key={index}
              className="bg-white dark:border-gray-700 dark:bg-gray-800"
            >
              <Table.Cell className="font-medium flex items-center text-gray-900 dark:text-white">
                <Avatar placeholderInitials="JD" className="mx-2" rounded />
                {influencer.name}
              </Table.Cell>
              <Table.Cell>{influencer.location}</Table.Cell>
              <Table.Cell>{influencer.followers.toLocaleString()}</Table.Cell>
              <Table.Cell className="text-green-600">Past Collaborator</Table.Cell>
              <Table.Cell>
                <Button className="bg-yellow-400">Connect</Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <div className="flex justify-center mt-4">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </section>
  );
};

export default PastCollaborations;

